import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep } from 'lodash'
import { getDataField } from 'utils/constants/dataFields'
import { DisplayAnswers } from 'components/DueDiligence/Questions'
import { formatToCPF } from 'brazilian-values'
import { formInfoinitialValues } from 'utils/constants/componentInitialValues'
import styles from './styles'



function FormDisplay(props) {
  const { formData, loading, showPersonInfo = true } = props
  const classes = styles()

  const [formResponses, setFormResponses] = useState(formInfoinitialValues)
  const [userData, setUserData] = useState({})

  const initilizeStates = async () => {
    if (formData?.owner) {
      setUserData(formData.owner)
    }
    if (formData?.answers?.length > 0) {
      const processedResponses = formData.answers.map(
        (answer) => answer.answer_object,
      )

      const updatedValues = cloneDeep(formInfoinitialValues)

      processedResponses.forEach((answer) => {
        updatedValues[answer.question_name].has_answer = true
        updatedValues[answer.question_name][
          getDataField(answer.question_name)
        ] = answer[getDataField(answer.question_name)]
      })
      setFormResponses(updatedValues)
    }
  }

  useEffect(() => {
    initilizeStates()
  }, [formData])

  return (
    <div className={classes.root}>
      {loading ? (
        <h3>Carregando</h3>
      ) : (
        <div className={classes.container}>
          {showPersonInfo ? (
            <div className={classes.prospectData}>
              <h3 className={classes.title}>Dados do candidato</h3>
              <div>
                <p>
                  <span>CPF: </span>
                  {userData?.prospect?.person?.cpf && formatToCPF(userData?.prospect?.person?.cpf)}
                </p>
                <p className={classes.textCapitalize}>
                  <span>Nome: </span>
                  {userData?.prospect?.person?.name?.toLowerCase()}
                </p>
                <p>
                  <span>Email: </span>
                  {userData?.email}
                </p>
              </div>
            </div>
          ) : null}
          <div className={classes.wrapper}>
            <DisplayAnswers formResponses={formResponses} condensed={true} />
          </div>
        </div>
      )}
    </div>
  )
}

FormDisplay.propTypes = {
  formData: PropTypes.object.isRequired,
  loading: PropTypes.bool,
}

FormDisplay.defaultProps = {
  loading: false,
}

export default FormDisplay
